export const ActionTypes = {
    UPDATE_COMPLETETASKS: "UPDATE_COMPLETETASKS_REQUEST",
    UPDATE_COMPLETETASKS_SUCCESS: "UPDATE_COMPLETETASKS_SUCCESS",
    UPDATE_COMPLETETASKS_FAILURE: "UPDATE_COMPLETETASKS_FAILURE",
}